module.exports = __webpack_public_path__ + "img/dev-heroes-1.91bad19e.webp";